import { createContext } from "react";

import { User } from "fe-shared/src/types/domain";

const UserContext = createContext(undefined as User | undefined);

export default UserContext;
